import React from 'react';
import { IParentComponent } from '../../../../tailwindComponents/interfaces/IParentComponent';
import classNames from 'classnames';

export const StyledCardTextTW: React.FC<{ 'data-test-id'?: string; children?: React.ReactNode }> = (props) => {
  return (
    <div data-test-id={props['data-test-id']} className={'pt-3 text-lg'}>
      {props.children}
    </div>
  );
};

export const StyledCardDivTW: React.FC<{ className?: string; 'data-test-id'?: string; children?: React.ReactNode }> = (
  props
) => {
  return (
    <div
      data-test-id={props['data-test-id']}
      className={classNames('flex flex-col border-l border-gray-300 p-4 first:border-0', props.className)}
    >
      {props.children}
    </div>
  );
};

export const CardFlexRowTW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className }) => {
  return <div className={classNames('flex flex-row gap-4', className)}>{children}</div>;
};
